// 訂房資訊
module.exports = [
  {
    name: 'W Taipei Hotel',
    address: `No.10 Zhongxiao East Road Sec. 5, Xinyi District, Taipei<br>Tel: +886-2-7703-8888<br><a href="http://www.wtaipei.com/" target="_blank">http://www.wtaipei.com/</a>`,
    star: '★★★★★'
  },
  {
    name: 'Le Méridien Taipei',
    address: `No.38 SongRen Road, Xinyi District Taipei, 110 Taiwan<br>Tel: +886-2-6622-8000<br><a href="http://www.lemeridien-taipei.com/" target="_blank">http://www.lemeridien-taipei.com/</a>`,
    star: '★★★★★'
  },
  {
    name: 'Grand Hyatt Taipei',
    address: `No.2, SongShou Road, Taipei, Taiwan, 11051<br>Tel: +886-2-2720-1234<br><a href="http://taipei.grand.hyatt.com/en/hotel/home.html" target="_blank">http://taipei.grand.hyatt.com/en/hotel/home.html</a>`,
    star: '★★★★★'
  },
  {
    name: 'Home Hotel Xinyi',
    address: `No.90, SongRen Rd., XinYi District, 101, Taipei, TW<br>Tel: +886-2-8789 0111<br><a href="http://www.homehotel.com.tw/xinyi.php" target="_blank">http://www.homehotel.com.tw/xinyi.php</a>`,
    star: '★★★★'
  },
  {
    name: 'Pacific Business Center',
    address: `11F, No.495, Guangfu South Road, Xinyi District, Taipei, 11074, Taiwan<br>Tel: +886-2-8780-8000<br><a href="http://www.businesscenter.com.tw" target="_blank">http://www.businesscenter.com.tw</a>`,
    star: '★★★☆'
  },
  {
    name: 'Sparkle Hotel',
    address: `B1, No. 16, Sec 5, Xin Yi Rd, Xin Yi District, 11049 Taipei<br>Tel: +886-2-2758-8881<br><a href="http://www.sparklehotel.com.tw/" target="_blank">http://www.sparklehotel.com.tw/</a>`,
    star: '★★★☆'
  },
  {
    name: 'AT Boutique Hotel',
    address: `3F., No.468, Sec. 4, Xinyi Rd., Xinyi Dist., Taipei City 110, Taiwan<br>Tel: +886-2-2345-9777<br><a href="http://www.at-boutique-hotel.com/" target="_blank">http://www.at-boutique-hotel.com/</a>`,
    star: '★★★'
  },
  {
    name: 'iTaipei2 Service Apartment',
    address: `No.226, Ln. 415, Guangfu S. Rd., Xinyi Dist., Taipei City 110, Taiwan<br>Tel: +886-2-2720-3668<br><a href="http://www.myresort.com.tw/itaipei2/en/2-2.asp" target="_blank">http://www.myresort.com.tw/itaipei2/en/2-2.asp</a>`,
    star: '★★★'
  }
]



// WEBPACK FOOTER //
// ./src/plugins/hotels.js